// Global auth token getter - will be set by the app
let globalGetAccessToken: (() => string | null) | null = null;
let globalAuthInstance: any = null;

export const setGlobalAuthTokenGetter = (tokenGetter: () => string | null) => {
  globalGetAccessToken = tokenGetter;
};

export const setGlobalAuthInstance = (authInstance: any) => {
  globalAuthInstance = authInstance;
};

export const getGlobalAuthInstance = () => {
  return globalAuthInstance;
};

export const getGlobalAccessToken = (): string | null => {
  if (globalGetAccessToken) {
    return globalGetAccessToken();
  }
  return null;
};

// Debug function to check localStorage for auth tokens
export const debugAuthTokens = () => {
  // Check all localStorage keys
  const keys = Object.keys(localStorage);

  // Look for OIDC-related keys
  const oidcKeys = keys.filter(key =>
    key.includes('oidc') ||
    key.includes('user') ||
    key.includes('token') ||
    key.includes('auth')
  );

  // Check each OIDC key
  oidcKeys.forEach(key => {
    try {
      const value = localStorage.getItem(key);
      if (value) {
      }
    } catch (e) {
      console.error(`${key}:`, localStorage.getItem(key));
    }
  });
};
